/* eslint-disable */
import * as SchemaTypes from '../../api/graphql/core/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProfileCompanyFragment = { __typename?: 'Profile', company?: { __typename?: 'ProfileEmployerConnection', edges: Array<{ __typename?: 'ProfileEmployerEdge', node: { __typename?: 'ProfileEmployer', id: number, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null } | null } }> } | null };

export type ProfileOverviewFragment = { __typename?: 'BaseProfile', id: any, type: SchemaTypes.BaseProfile_Type_Enum, profile?: { __typename?: 'Profile', id: any, firstName: string, lastName: string, location?: string | null, bio?: string | null, userId: any, avatar?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'ProfileFieldConnection', edges: Array<{ __typename?: 'ProfileFieldEdge', node: { __typename?: 'ProfileField', id: number, skillCategoryId: number } }> } | null, interests?: { __typename?: 'ProfileInterestConnection', edges: Array<{ __typename?: 'ProfileInterestEdge', node: { __typename?: 'ProfileInterest', id: number, skillCategoryId: number } }> } | null, company?: { __typename?: 'ProfileEmployerConnection', edges: Array<{ __typename?: 'ProfileEmployerEdge', node: { __typename?: 'ProfileEmployer', id: number, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null } | null } }> } | null } | null, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, location?: string | null, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, headerImage?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'CompanyProfileFieldConnection', edges: Array<{ __typename?: 'CompanyProfileFieldEdge', node: { __typename?: 'CompanyProfileField', id: number, skillCategoryId: number } }> } | null, vacancyCollection?: { __typename?: 'VacancyConnection', edges: Array<{ __typename?: 'VacancyEdge', node: { __typename?: 'Vacancy', id: any } }> } | null } | null };

export type PersonProfileOverviewFragment = { __typename?: 'Profile', id: any, firstName: string, lastName: string, location?: string | null, bio?: string | null, userId: any, avatar?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'ProfileFieldConnection', edges: Array<{ __typename?: 'ProfileFieldEdge', node: { __typename?: 'ProfileField', id: number, skillCategoryId: number } }> } | null, interests?: { __typename?: 'ProfileInterestConnection', edges: Array<{ __typename?: 'ProfileInterestEdge', node: { __typename?: 'ProfileInterest', id: number, skillCategoryId: number } }> } | null, company?: { __typename?: 'ProfileEmployerConnection', edges: Array<{ __typename?: 'ProfileEmployerEdge', node: { __typename?: 'ProfileEmployer', id: number, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null } | null } }> } | null };

export type CompanyProfileOverviewFragment = { __typename?: 'CompanyProfile', id: any, name: string, location?: string | null, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, headerImage?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'CompanyProfileFieldConnection', edges: Array<{ __typename?: 'CompanyProfileFieldEdge', node: { __typename?: 'CompanyProfileField', id: number, skillCategoryId: number } }> } | null, vacancyCollection?: { __typename?: 'VacancyConnection', edges: Array<{ __typename?: 'VacancyEdge', node: { __typename?: 'Vacancy', id: any } }> } | null };

export type SkillFragment = { __typename?: 'UserSkill', id: any, voteCount: number, skillId: number, skillCategoryId?: number | null, skill?: { __typename?: 'Skill', id: number, name: string } | null };

export type ProfileDetailsFragment = { __typename?: 'Profile', id: any, firstName: string, lastName: string, location?: string | null, bio?: string | null, userId: any, availability?: { __typename?: 'JobAvailability', id: any, availability: boolean, hoursPerWeekMin?: number | null, hoursPerWeekMax?: number | null, startDate?: any | null } | null, certifications?: { __typename?: 'ProfileCertificationConnection', edges: Array<{ __typename?: 'ProfileCertificationEdge', node: { __typename?: 'ProfileCertification', id: any, title: string, issuedBy: string, issueDate: any } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, educations?: { __typename?: 'ProfileEducationConnection', edges: Array<{ __typename?: 'ProfileEducationEdge', node: { __typename?: 'ProfileEducation', id: any, fieldOfStudy: string, school: string, endDate: any } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, languages?: { __typename?: 'ProfileLanguageProficiencyConnection', edges: Array<{ __typename?: 'ProfileLanguageProficiencyEdge', node: { __typename?: 'ProfileLanguageProficiency', id: any, languageTag: string, proficiency: string, language?: { __typename?: 'Language', tag: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, avatar?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'ProfileFieldConnection', edges: Array<{ __typename?: 'ProfileFieldEdge', node: { __typename?: 'ProfileField', id: number, skillCategoryId: number } }> } | null, interests?: { __typename?: 'ProfileInterestConnection', edges: Array<{ __typename?: 'ProfileInterestEdge', node: { __typename?: 'ProfileInterest', id: number, skillCategoryId: number } }> } | null, company?: { __typename?: 'ProfileEmployerConnection', edges: Array<{ __typename?: 'ProfileEmployerEdge', node: { __typename?: 'ProfileEmployer', id: number, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null } | null } }> } | null };

export type CertificationFragment = { __typename?: 'ProfileCertification', id: any, title: string, issuedBy: string, issueDate: any };

export type EducationFragment = { __typename?: 'ProfileEducation', id: any, fieldOfStudy: string, school: string, endDate: any };

export type CompanyProfileDetailsFragment = { __typename?: 'CompanyProfile', website?: string | null, description?: string | null, id: any, name: string, location?: string | null, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, headerImage?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'CompanyProfileFieldConnection', edges: Array<{ __typename?: 'CompanyProfileFieldEdge', node: { __typename?: 'CompanyProfileField', id: number, skillCategoryId: number } }> } | null, vacancyCollection?: { __typename?: 'VacancyConnection', edges: Array<{ __typename?: 'VacancyEdge', node: { __typename?: 'Vacancy', id: any } }> } | null };

export type ProfileIdQueryVariables = SchemaTypes.Exact<{
  userId?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['UUID']>;
  profileId?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['UUID']>;
  hasProfileId: SchemaTypes.Scalars['Boolean'];
}>;


export type ProfileIdQuery = { __typename?: 'Query', profile?: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: any, userId: any } }> } | null, companyProfile?: { __typename?: 'CompanyProfileConnection', edges: Array<{ __typename?: 'CompanyProfileEdge', node: { __typename?: 'CompanyProfile', id: any } }> } | null };

export type ProfileDetailsQueryVariables = SchemaTypes.Exact<{
  profileId?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['UUID']>;
  userId?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['UUID']>;
  certCursor?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Cursor']>;
  eduCursor?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Cursor']>;
  langCursor?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Cursor']>;
}>;


export type ProfileDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename: 'Profile', id: any, firstName: string, lastName: string, location?: string | null, bio?: string | null, userId: any, availability?: { __typename?: 'JobAvailability', id: any, availability: boolean, hoursPerWeekMin?: number | null, hoursPerWeekMax?: number | null, startDate?: any | null } | null, certifications?: { __typename?: 'ProfileCertificationConnection', edges: Array<{ __typename?: 'ProfileCertificationEdge', node: { __typename?: 'ProfileCertification', id: any, title: string, issuedBy: string, issueDate: any } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, educations?: { __typename?: 'ProfileEducationConnection', edges: Array<{ __typename?: 'ProfileEducationEdge', node: { __typename?: 'ProfileEducation', id: any, fieldOfStudy: string, school: string, endDate: any } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, languages?: { __typename?: 'ProfileLanguageProficiencyConnection', edges: Array<{ __typename?: 'ProfileLanguageProficiencyEdge', node: { __typename?: 'ProfileLanguageProficiency', id: any, languageTag: string, proficiency: string, language?: { __typename?: 'Language', tag: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, avatar?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'ProfileFieldConnection', edges: Array<{ __typename?: 'ProfileFieldEdge', node: { __typename?: 'ProfileField', id: number, skillCategoryId: number } }> } | null, interests?: { __typename?: 'ProfileInterestConnection', edges: Array<{ __typename?: 'ProfileInterestEdge', node: { __typename?: 'ProfileInterest', id: number, skillCategoryId: number } }> } | null, company?: { __typename?: 'ProfileEmployerConnection', edges: Array<{ __typename?: 'ProfileEmployerEdge', node: { __typename?: 'ProfileEmployer', id: number, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null } | null } }> } | null } }> } | null };

export type CompanyProfileDetailsQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['UUID'];
}>;


export type CompanyProfileDetailsQuery = { __typename?: 'Query', companyProfile?: { __typename?: 'CompanyProfileConnection', edges: Array<{ __typename?: 'CompanyProfileEdge', node: { __typename?: 'CompanyProfile', website?: string | null, description?: string | null, id: any, name: string, location?: string | null, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, headerImage?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'CompanyProfileFieldConnection', edges: Array<{ __typename?: 'CompanyProfileFieldEdge', node: { __typename?: 'CompanyProfileField', id: number, skillCategoryId: number } }> } | null, vacancyCollection?: { __typename?: 'VacancyConnection', edges: Array<{ __typename?: 'VacancyEdge', node: { __typename?: 'Vacancy', id: any } }> } | null } }> } | null };

export type ProfileOverviewQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['UUID'];
  userId: SchemaTypes.Scalars['UUID'];
  myUserId: SchemaTypes.Scalars['UUID'];
  isAuthenticated: SchemaTypes.Scalars['Boolean'];
}>;


export type ProfileOverviewQuery = { __typename?: 'Query', overview?: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: any, firstName: string, lastName: string, location?: string | null, bio?: string | null, userId: any, avatar?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'ProfileFieldConnection', edges: Array<{ __typename?: 'ProfileFieldEdge', node: { __typename?: 'ProfileField', id: number, skillCategoryId: number } }> } | null, interests?: { __typename?: 'ProfileInterestConnection', edges: Array<{ __typename?: 'ProfileInterestEdge', node: { __typename?: 'ProfileInterest', id: number, skillCategoryId: number } }> } | null, company?: { __typename?: 'ProfileEmployerConnection', edges: Array<{ __typename?: 'ProfileEmployerEdge', node: { __typename?: 'ProfileEmployer', id: number, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null } | null } }> } | null } }> } | null, companyProfile?: { __typename?: 'CompanyProfileConnection', edges: Array<{ __typename?: 'CompanyProfileEdge', node: { __typename?: 'CompanyProfile', id: any, name: string, location?: string | null, logo?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, headerImage?: { __typename?: 'Media', id: any, URI: string, updatedAt: any } | null, fields?: { __typename?: 'CompanyProfileFieldConnection', edges: Array<{ __typename?: 'CompanyProfileFieldEdge', node: { __typename?: 'CompanyProfileField', id: number, skillCategoryId: number } }> } | null, vacancyCollection?: { __typename?: 'VacancyConnection', edges: Array<{ __typename?: 'VacancyEdge', node: { __typename?: 'Vacancy', id: any } }> } | null } }> } | null, likes?: { __typename?: 'LikeConnection', edges: Array<{ __typename?: 'LikeEdge', node: { __typename?: 'Like', id: any } }> } | null };

export type UserSkillsQueryVariables = SchemaTypes.Exact<{
  userId: SchemaTypes.Scalars['UUID'];
  after?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Cursor']>;
}>;


export type UserSkillsQuery = { __typename?: 'Query', collection?: { __typename?: 'UserSkillConnection', edges: Array<{ __typename?: 'UserSkillEdge', node: { __typename?: 'UserSkill', id: any, voteCount: number, skillId: number, skillCategoryId?: number | null, skill?: { __typename?: 'Skill', id: number, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ProfileSkillsQueryVariables = SchemaTypes.Exact<{
  profileId: SchemaTypes.Scalars['UUID'];
  after?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Cursor']>;
}>;


export type ProfileSkillsQuery = { __typename?: 'Query', collection?: { __typename?: 'ProfileSkillConnection', edges: Array<{ __typename?: 'ProfileSkillEdge', node: { __typename?: 'ProfileSkill', id: any, rateAverage?: number | null, rateCount: number, skillId: number, skillCategoryId?: number | null, profileSkillAppreciationCollection?: { __typename?: 'ProfileSkillAppreciationConnection', edges: Array<{ __typename?: 'ProfileSkillAppreciationEdge', node: { __typename?: 'ProfileSkillAppreciation', id: any, rater?: { __typename?: 'BaseProfile', profile?: { __typename?: 'Profile', firstName: string, lastName: string } | null, companyProfile?: { __typename?: 'CompanyProfile', name: string } | null } | null } }> } | null, skill?: { __typename?: 'Skill', id: number, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export const ProfileCompanyFragmentDoc = gql`
    fragment ProfileCompany on Profile {
  company: profileEmployerCollection {
    edges {
      node {
        id
        companyProfile {
          id
          name
          logo {
            id
            URI
            updatedAt
          }
        }
      }
    }
  }
}
    `;
export const PersonProfileOverviewFragmentDoc = gql`
    fragment PersonProfileOverview on Profile {
  id
  firstName
  lastName
  location
  bio
  userId
  avatar {
    id
    URI
    updatedAt
  }
  fields: profileFieldCollection {
    edges {
      node {
        id
        skillCategoryId
      }
    }
  }
  interests: profileInterestCollection {
    edges {
      node {
        id
        skillCategoryId
      }
    }
  }
  ...ProfileCompany
}
    ${ProfileCompanyFragmentDoc}`;
export const CompanyProfileOverviewFragmentDoc = gql`
    fragment CompanyProfileOverview on CompanyProfile {
  id
  name
  logo {
    id
    URI
    updatedAt
  }
  headerImage {
    id
    URI
    updatedAt
  }
  location
  fields: companyProfileFieldCollection {
    edges {
      node {
        id
        skillCategoryId
      }
    }
  }
  vacancyCollection {
    edges {
      node {
        id
      }
    }
  }
}
    `;
export const ProfileOverviewFragmentDoc = gql`
    fragment ProfileOverview on BaseProfile {
  id
  type
  profile {
    ...PersonProfileOverview
  }
  companyProfile {
    ...CompanyProfileOverview
  }
}
    ${PersonProfileOverviewFragmentDoc}
${CompanyProfileOverviewFragmentDoc}`;
export const SkillFragmentDoc = gql`
    fragment Skill on UserSkill {
  id
  voteCount
  skillId
  skillCategoryId
  skill {
    id
    name
  }
}
    `;
export const CertificationFragmentDoc = gql`
    fragment Certification on ProfileCertification {
  id
  title
  issuedBy
  issueDate
}
    `;
export const EducationFragmentDoc = gql`
    fragment Education on ProfileEducation {
  id
  fieldOfStudy
  school
  endDate
}
    `;
export const ProfileDetailsFragmentDoc = gql`
    fragment ProfileDetails on Profile {
  ...PersonProfileOverview
  availability: jobAvailability {
    id
    availability
    hoursPerWeekMin
    hoursPerWeekMax
    startDate
  }
  certifications: profileCertificationCollection(after: $certCursor) {
    edges {
      node {
        ...Certification
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  educations: profileEducationCollection(after: $eduCursor) {
    edges {
      node {
        ...Education
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  languages: profileLanguageProficiencyCollection(after: $langCursor) {
    edges {
      node {
        id
        languageTag
        proficiency
        language {
          tag
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${PersonProfileOverviewFragmentDoc}
${CertificationFragmentDoc}
${EducationFragmentDoc}`;
export const CompanyProfileDetailsFragmentDoc = gql`
    fragment CompanyProfileDetails on CompanyProfile {
  ...CompanyProfileOverview
  website
  description
}
    ${CompanyProfileOverviewFragmentDoc}`;
export const ProfileIdDocument = gql`
    query ProfileId($userId: UUID, $profileId: UUID, $hasProfileId: Boolean!) {
  profile: profileCollection(
    filter: {id: {eq: $profileId}, userId: {eq: $userId}}
  ) {
    edges {
      node {
        id
        userId
      }
    }
  }
  companyProfile: companyProfileCollection(filter: {id: {eq: $profileId}}) @include(if: $hasProfileId) {
    edges {
      node {
        id
      }
    }
  }
}
    `;
export function useProfileIdQuery(baseOptions: Apollo.QueryHookOptions<ProfileIdQuery, ProfileIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileIdQuery, ProfileIdQueryVariables>(ProfileIdDocument, options);
      }
export function useProfileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileIdQuery, ProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileIdQuery, ProfileIdQueryVariables>(ProfileIdDocument, options);
        }
export type ProfileIdQueryHookResult = ReturnType<typeof useProfileIdQuery>;
export type ProfileIdLazyQueryHookResult = ReturnType<typeof useProfileIdLazyQuery>;
export type ProfileIdQueryResult = Apollo.QueryResult<ProfileIdQuery, ProfileIdQueryVariables>;
export const ProfileDetailsDocument = gql`
    query ProfileDetails($profileId: UUID, $userId: UUID, $certCursor: Cursor, $eduCursor: Cursor, $langCursor: Cursor) {
  profile: profileCollection(
    filter: {userId: {eq: $userId}, id: {eq: $profileId}}
  ) {
    edges {
      node {
        __typename
        ...ProfileDetails
      }
    }
  }
}
    ${ProfileDetailsFragmentDoc}`;
export function useProfileDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ProfileDetailsQuery, ProfileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileDetailsQuery, ProfileDetailsQueryVariables>(ProfileDetailsDocument, options);
      }
export function useProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileDetailsQuery, ProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileDetailsQuery, ProfileDetailsQueryVariables>(ProfileDetailsDocument, options);
        }
export type ProfileDetailsQueryHookResult = ReturnType<typeof useProfileDetailsQuery>;
export type ProfileDetailsLazyQueryHookResult = ReturnType<typeof useProfileDetailsLazyQuery>;
export type ProfileDetailsQueryResult = Apollo.QueryResult<ProfileDetailsQuery, ProfileDetailsQueryVariables>;
export const CompanyProfileDetailsDocument = gql`
    query CompanyProfileDetails($id: UUID!) {
  companyProfile: companyProfileCollection(filter: {id: {eq: $id}}) {
    edges {
      node {
        ...CompanyProfileDetails
      }
    }
  }
}
    ${CompanyProfileDetailsFragmentDoc}`;
export function useCompanyProfileDetailsQuery(baseOptions: Apollo.QueryHookOptions<CompanyProfileDetailsQuery, CompanyProfileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyProfileDetailsQuery, CompanyProfileDetailsQueryVariables>(CompanyProfileDetailsDocument, options);
      }
export function useCompanyProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyProfileDetailsQuery, CompanyProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyProfileDetailsQuery, CompanyProfileDetailsQueryVariables>(CompanyProfileDetailsDocument, options);
        }
export type CompanyProfileDetailsQueryHookResult = ReturnType<typeof useCompanyProfileDetailsQuery>;
export type CompanyProfileDetailsLazyQueryHookResult = ReturnType<typeof useCompanyProfileDetailsLazyQuery>;
export type CompanyProfileDetailsQueryResult = Apollo.QueryResult<CompanyProfileDetailsQuery, CompanyProfileDetailsQueryVariables>;
export const ProfileOverviewDocument = gql`
    query ProfileOverview($id: UUID!, $userId: UUID!, $myUserId: UUID!, $isAuthenticated: Boolean!) {
  overview: profileCollection(filter: {id: {eq: $id}}) {
    edges {
      node {
        ...PersonProfileOverview
      }
    }
  }
  companyProfile: companyProfileCollection(filter: {id: {eq: $id}}) {
    edges {
      node {
        ...CompanyProfileOverview
      }
    }
  }
  likes: likeCollection(filter: {userId: {eq: $userId}}) {
    edges {
      node {
        id
      }
    }
  }
}
    ${PersonProfileOverviewFragmentDoc}
${CompanyProfileOverviewFragmentDoc}`;
export function useProfileOverviewQuery(baseOptions: Apollo.QueryHookOptions<ProfileOverviewQuery, ProfileOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileOverviewQuery, ProfileOverviewQueryVariables>(ProfileOverviewDocument, options);
      }
export function useProfileOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileOverviewQuery, ProfileOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileOverviewQuery, ProfileOverviewQueryVariables>(ProfileOverviewDocument, options);
        }
export type ProfileOverviewQueryHookResult = ReturnType<typeof useProfileOverviewQuery>;
export type ProfileOverviewLazyQueryHookResult = ReturnType<typeof useProfileOverviewLazyQuery>;
export type ProfileOverviewQueryResult = Apollo.QueryResult<ProfileOverviewQuery, ProfileOverviewQueryVariables>;
export const UserSkillsDocument = gql`
    query UserSkills($userId: UUID!, $after: Cursor) {
  collection: userSkillCollection(
    filter: {userId: {eq: $userId}}
    orderBy: [{voteCount: DescNullsLast}]
    after: $after
  ) {
    edges {
      node {
        ...Skill
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SkillFragmentDoc}`;
export function useUserSkillsQuery(baseOptions: Apollo.QueryHookOptions<UserSkillsQuery, UserSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSkillsQuery, UserSkillsQueryVariables>(UserSkillsDocument, options);
      }
export function useUserSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSkillsQuery, UserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSkillsQuery, UserSkillsQueryVariables>(UserSkillsDocument, options);
        }
export type UserSkillsQueryHookResult = ReturnType<typeof useUserSkillsQuery>;
export type UserSkillsLazyQueryHookResult = ReturnType<typeof useUserSkillsLazyQuery>;
export type UserSkillsQueryResult = Apollo.QueryResult<UserSkillsQuery, UserSkillsQueryVariables>;
export const ProfileSkillsDocument = gql`
    query ProfileSkills($profileId: UUID!, $after: Cursor) {
  collection: profileSkillCollection(
    filter: {baseProfileId: {eq: $profileId}}
    orderBy: [{rateAverage: DescNullsLast}]
    after: $after
  ) {
    edges {
      node {
        id
        rateAverage
        rateCount
        skillId
        skillCategoryId
        profileSkillAppreciationCollection {
          edges {
            node {
              id
              rater {
                profile {
                  firstName
                  lastName
                }
                companyProfile {
                  name
                }
              }
            }
          }
        }
        skill {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export function useProfileSkillsQuery(baseOptions: Apollo.QueryHookOptions<ProfileSkillsQuery, ProfileSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileSkillsQuery, ProfileSkillsQueryVariables>(ProfileSkillsDocument, options);
      }
export function useProfileSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileSkillsQuery, ProfileSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileSkillsQuery, ProfileSkillsQueryVariables>(ProfileSkillsDocument, options);
        }
export type ProfileSkillsQueryHookResult = ReturnType<typeof useProfileSkillsQuery>;
export type ProfileSkillsLazyQueryHookResult = ReturnType<typeof useProfileSkillsLazyQuery>;
export type ProfileSkillsQueryResult = Apollo.QueryResult<ProfileSkillsQuery, ProfileSkillsQueryVariables>;